// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asset-timeline {
    container: asset-timeline / inline-size;
}

.asset-timeline .timeline-rail-fade {
    min-height: 48px;
}

@container asset-timeline (max-width: 25rem) {
    .asset-timeline .asset-timeline-scroll {
        height: 344px;
    }
}

/* Timeline scrollbar (Figma spec): thin grey thumb, no arrow buttons.
   Deliberately no \`scrollbar-width\`/\`scrollbar-color\`: setting either makes Chromium 121+
   switch to the standard (Fluent) scrollbar, which draws arrow buttons and ignores every
   ::-webkit-scrollbar rule below. Mirrors \`.ess-timeline-scroll\` in EssHistoricalInfo.css. */
.asset-timeline-scroll::-webkit-scrollbar {
    background: transparent;
    width: 4px;
}

.asset-timeline-scroll::-webkit-scrollbar-track {
    background: transparent;
}

.asset-timeline-scroll::-webkit-scrollbar-thumb {
    background: #ccc;
    background: var(--bg-subtle-hover, #ccc);
    border: 0;
    border-radius: 2px;
}

.asset-timeline-scroll::-webkit-scrollbar-button {
    display: none;
    height: 0;
    width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/AssetTimeline/AssetTimeline.css"],"names":[],"mappings":"AAAA;IACI,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;;;6FAG6F;AAC7F;IACI,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAwC;IAAxC,wCAAwC;IACxC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,QAAQ;AACZ","sourcesContent":[".asset-timeline {\n    container: asset-timeline / inline-size;\n}\n\n.asset-timeline .timeline-rail-fade {\n    min-height: 48px;\n}\n\n@container asset-timeline (max-width: 25rem) {\n    .asset-timeline .asset-timeline-scroll {\n        height: 344px;\n    }\n}\n\n/* Timeline scrollbar (Figma spec): thin grey thumb, no arrow buttons.\n   Deliberately no `scrollbar-width`/`scrollbar-color`: setting either makes Chromium 121+\n   switch to the standard (Fluent) scrollbar, which draws arrow buttons and ignores every\n   ::-webkit-scrollbar rule below. Mirrors `.ess-timeline-scroll` in EssHistoricalInfo.css. */\n.asset-timeline-scroll::-webkit-scrollbar {\n    background: transparent;\n    width: 4px;\n}\n\n.asset-timeline-scroll::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.asset-timeline-scroll::-webkit-scrollbar-thumb {\n    background: var(--bg-subtle-hover, #ccc);\n    border: 0;\n    border-radius: 2px;\n}\n\n.asset-timeline-scroll::-webkit-scrollbar-button {\n    display: none;\n    height: 0;\n    width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
